module.exports = __webpack_public_path__ + "static/img/Telefonica_MG_3331-web.05d1dfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/Telefonica_MG_3331-web.jpg
// module id = 69tU
// module chunks = 0